import { render, staticRenderFns } from "./MoleculeProjectSliderBackground.vue?vue&type=template&id=13bfe0f1&scoped=true&"
import script from "./MoleculeProjectSliderBackground.vue?vue&type=script&lang=js&"
export * from "./MoleculeProjectSliderBackground.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeProjectSliderBackground.vue?vue&type=style&index=0&id=13bfe0f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfe0f1",
  null
  
)

export default component.exports